<template>
  <v-list-item :href="path" link>
    <v-list-item-action>
      <v-icon color="white">{{ icon }}</v-icon>
    </v-list-item-action>
    <v-list-item-content>
      <v-list-item-title class="white--text">
        {{ name }}
        <slot />
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'MenuLink',
  props: {
    path: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: 'Link name'
    },
    icon: {
      type: String,
      default: ''
    }
  }
}
</script>
